<script>
  export let callback;

  import { Card, Table } from 'sveltestrap';
  import { from } from './from.js'

  let gurl = "https://docs.google.com/spreadsheets/u/1/d/1X0XhjhAWtBfToj-dall9rK8TrWzf2CwzK8S14xgRdho/gviz/tq?tqx=out:html&sheet=Sheet1&range=e1:f5";
  let gsheet;
  let grange;
  let previewTable;

  let dump = ' -- preview area -- ';
  function updateLink() {
    console.log('DSGooSheet.updateLink - ', gurl, dump)
    from(gurl)
    .then(r => r.text())
    .then(t => {
      console.log(t);
      dump = t;
    })
    .catch(ex => {
      console.log("DataSetGoogleSheet - ", ex, gurl)
    })
  }

</script>

<Card body>

  <label>URL:   <input type=text name=sheet_url   on:blur={updateLink} value={gurl}   ></label><br>
  <label>Sheet: <input type=text name=sheet_sheet on:blur={updateLink} value={gsheet} ></label><br>
  <label>Range: <input type=text name=sheet_range on:blur={updateLink} value={grange} ></label><br>
  
  <Table bind:this={previewTable}  >

  </Table>

  <Card body>{dump}</Card>
</Card>
